<template>
    <img
        v-if="user.avatarUrl"
        class="rounded-full"
        :src="user.avatarUrl"
        alt=""
    >
    <span
        v-else
        class="inline-flex items-center justify-center rounded-full bg-indigo-100 text-indigo-700 font-semibold select-none"
        :style="{ fontSize: '0.8em' }"
        aria-hidden="true"
    >
        {{ initials }}
    </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { User } from "@/stores/user";

const props = defineProps<{ user: User }>();

const initials = computed(() =>
    props.user.name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join("")
);
</script>
